<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <p><span class="pc-browser">VALSE&nbsp;&nbsp;2025&nbsp;&nbsp;</span>Workshops</p>
    </div>

    <div class="main-container detail-main-content">
      <div class="back-page-btn" @click="backpage()">返回</div>
      <div class="content-item-grp">
        <div class="content-item detail-page-item">
          <div class="item-title">
            <span class="item-title-content">
              <div>{{workshop.title}}</div>
            </span>
          </div>
          <div class="item-content">
            <div class="workshop-item">
              <div class="workshop-info-label">
                <div class="workshop-content">
                  {{workshop.content}}
                </div>
                <div><b>组织者：</b></div>

                <!-- <div class="organizer-contain" v-for="organizer in workshop.organizers">
                  {{organizer.name}}
                  <template v-if="organizer.unit!= ''">
                    ({{organizer.unit}})
                  </template>

                </div> -->
                <div class="workshop-speaker-contain">
                <template  v-for="speaker in workshop.organizers">
                  <template  v-if="speaker.homepage!= ''">
                    <a class="workshop-speaker" target="_blank" :href="speaker.homepage">
                      <div class="speaker-image" :style="{'background-image':'url('+speaker.image+')'}">
                    </div>
                      <div class="workshop-speaker-label-info">{{speaker.name}}</div>
                      <div class="workshop-speaker-label-info">{{speaker.unit}}</div>
                    </a>
                  </template>
                  <template v-else>
                    <a class="workshop-speaker">
                       <div class="speaker-image" :style="{'background-image':'url('+speaker.image+')'}">
                    </div>
                      <div class="workshop-speaker-label-info">{{speaker.name}}</div>
                      <div class="workshop-speaker-label-info">{{speaker.unit}}</div>
                    </a>
                  </template>
                </template>
                </div>

              </div>
              <!-- <div class="workshop-info-label"  v-show="true">地点：<span class="text-red">{{workshop.time}}</span> </div> -->
              <div class="workshop-info-label"  v-show="true"><b>讲者：</b></div>
              <div class="workshop-speaker-contain"  v-show="true">
                <template  v-for="speaker in workshop.speakers">
                  <template  v-if="speaker.homepage!= ''">
                    <a class="workshop-speaker" target="_blank" :href="speaker.homepage">
                      <div class="speaker-image" :style="{'background-image':'url('+speaker.image+')'}">
                    </div>
                      <div class="workshop-speaker-label-info">{{speaker.name}}</div>
                      <div class="workshop-speaker-label-info">{{speaker.unit}}</div>
                    </a>
                  </template>
                  <template v-else>
                    <a class="workshop-speaker">
                       <div class="speaker-image" :style="{'background-image':'url('+speaker.image+')'}">
                    </div>
                      <div class="workshop-speaker-label-info">{{speaker.name}}</div>
                      <div class="workshop-speaker-label-info">{{speaker.unit}}</div>
                    </a>
                  </template>
                </template>

              </div>
              <div class="workshop-info-label"  v-show="true"><b>讲者介绍：</b></div>
              <div class="workshop-speaker-item" v-for="speaker in workshop.speakers"  v-show="true">
                <!-- <div class="speaker-item-images" :style="{'background-image':'url('+speaker.image+')'}"></div> -->
                <!-- <template v-if="speaker.image==='static/images/workshop/'">
                  <div class="speaker-item-images" :style="{'background-image':'url(static/images/touxiang.png)'}"></div>
                </template>
                <template v-else> -->
                  <div class="speaker-item-images" :style="{'background-image':'url('+speaker.image+')'}"></div>
                <!-- </template> -->
                <div class="speaker-item-intro">
                  <div class="item-name">{{speaker.name}}</div>
                  <div class="item-name">{{speaker.unit}}</div>
                  {{speaker.resume}}
                </div>
                <div class="report-item-contain">
                  <div class="report-title-contain">
                    <span class="report-title-label pc-browser">报告题目：</span>
                    <span class="report-title">{{speaker.reportTitle}}</span>
                  </div>
                  <div class="report-abstract">
                    <span style="white-space: pre-wrap;">{{speaker.reportAbstract}}</span>
                  </div>
                </div>
              </div>
              
              <template  v-if="this.$route.query.id==4">
                <div class="workshop-info-label"  v-show="true"><b>Panel嘉宾：</b></div>
              <div class="workshop-info-label">报告嘉宾 + 3名优秀学生</div>
              <div class="speakerandpanel-contain">
                <p>Panel学生嘉宾：</p>

                <!-- <p>请研究方向与本论坛学术领域高度契合且有意担任Panel嘉宾的在校学生，在线填写并提交报名表。截止时间：2025年5月11日。</p> -->

                <!-- <p>报名链接（浏览器）：<a href="https://www.wjx.cn/vm/QTzCoWn.aspx#" target="__blank">https://www.wjx.cn/vm/QTzCoWn.aspx#</a></p> -->

                <!-- <p>报名链接（二维码）：</p> -->
                <!-- <img src="static/images/workshop/w9_erweima.jpg"> -->

              </div>
                </template>
                <template v-else>
                <div class="workshop-info-label"  v-show="true"><b>Panel嘉宾：</b><span class="small-label">（详见讲者或组织者介绍）</span></div>

                </template>
              <div class="speakerandpanel-contain">
                <span v-for="panel in workshop.panelGuests">{{panel}}
                   </span>
              </div>
              <div class="workshop-speaker-item" v-for="panelGuest in workshop.reportAndPanel">
                <div class="speaker-item-images" :style="{'background-image':'url('+panelGuest.image+')'}"></div>
                <div class="speaker-item-intro">
                  <div class="item-name">{{panelGuest.name}}</div>
                  <div class="item-name">{{panelGuest.unit}}</div>
                  {{panelGuest.resume}}
                </div>
              </div>
              <div class="workshop-info-label"  v-show="true"><b>组织者介绍：</b></div>
              <div class="workshop-speaker-item" v-for="panelGuest in workshop.organizers"  v-show="true">
                <!-- <template v-if="panelGuest.image==='static/images/workshop/'">
                  <div class="speaker-item-images" :style="{'background-image':'url(static/images/touxiang.png)'}"></div>
                </template>
                <template v-else> -->
                  <div class="speaker-item-images" :style="{'background-image':'url('+panelGuest.image+')'}"></div>
                <!-- </template> -->
                <div class="speaker-item-intro">
                  <div class="item-name">{{panelGuest.name}}</div>
                  <div class="item-name">{{panelGuest.unit}}</div>
                  {{panelGuest.resume}}
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "Workshop",
        data() {
          return {
            workshop:this.$dicts.workshopList[this.$route.query.id],
          }
        },
        methods: {
          handleChange(val) {
            console.log(val);
          },
          backpage(){
            this.$router.back(-1);
          }
        },
      mounted(){
          document.body.scrollTop = document.documentElement.scrollTop = this.scrollTop
      }
    }
</script>

<style scoped>
.footer{
    /* position: fixed; */
    bottom: 0;
  }
  .detail-main-content{
    margin-top: 12px;
  }
  .detail-page-item{
    margin: 0 auto;
    margin-bottom: 60px;
  }
  .program_banner{
    background-image: url("../../static/images/workshop-banner.png");
  }
  .workshop-content{
    margin: 24px 0;
    text-align: left;
    text-indent: 2em;
  }
  .workshop-item{
    text-align: left;
    padding: 0 16px;
  }
  .workshop-item .workshop-title{
    font-size: 16px;
    color: #0053a1;
    font-weight: 700;
    /*border-left: 1px solid #0053a1;*/
  }
  .workshop-item .workshop-info-label{
    font-size: 18px;
    color: #2c3e50;
    font-weight: 500;
    margin: 8px 0;
  }
  .workshop-item .organizer-contain{
    margin-left: 50px;
    font-weight: normal;
  }
  .workshop-speaker-contain{
    display: flex;
    flex-wrap: wrap;
    flex-direction:row;
    justify-content:flex-start ;
    /* justify-content:center; */
    align-items:stretch;
    align-content:flex-start;
    padding: 0 24px;
  }
  .workshop-speaker-contain .workshop-speaker{
    width: 130px;
    /*height: 200px;*/
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #409EFF;
    border-bottom: 2px solid #FFF;
    margin: 8px;
  }
  .workshop-speaker-contain .workshop-speaker:hover{
    cursor: pointer;
    border-bottom: 2px solid #0053a1;
    /*border-radius: 8px;*/
    color: #0053a1;
  }
  .workshop-speaker-contain .workshop-speaker img{
    width: 112px;
    margin: 0 auto;
    border-radius: 56px;
    border: 1px solid #909399;

    /*height: 100%;*/
  }
  .content-item .speaker-item{
    /*border: 1px solid red;*/
  }
  .content-item .speaker-item .speaker-info{
    /*width: 300px;*/
    height: 120px;
    /*border: 1px solid red;*/
    text-align: left;
    display: flex;
    align-items:flex-end;
    position: relative;
    bottom: -40px;
  }
  .speaker-info .speaker-info-base{
    padding: 8px;
    padding-bottom: 40px;
  }
  .speaker-info .speaker-info-base .speaker-name{
    color: #0e5ca5;
    font-weight: 500;
  }
  /*.speaker-image{*/
    /*width: 120px;*/
    /*height: 100%;*/
  /*}*/
  .speaker-image{
    width: 120px;
    height: 120px;
    margin: 12px auto;
    background-size: cover;
    background-repeat: no-repeat;
    /*background-position: center;*/
    border-radius: 30px;
  }
  .speaker-image img{
    width: 100%;
    border: 1px solid #00a0e9;
  }
  .content-item .speaker-item .speaker-content{
    border: 1px solid #0e5ca5;
    padding: 16px;
  }
  .speaker-content .speaker-report-title{
    color: #303133;
    font-size: 20px;
    font-weight: 700;
    padding-top: 16px;
  }
  .speaker-content .speaker-report-content p{
    text-indent: 2em;
    text-align: justify;
  }
  .info-label{
		color: red;
		font-weight: 500;
	}
  .item-title-label a{
    font-size: 14px;

  }
  
  .item-content{
    margin-top: -30px;
  }
  .item-title-label .el-button--text{
    color: red;
		font-weight: 500;
  }
  .workshop-speaker-item{
    margin-bottom: 32px;
    background-color: #efefef;
    padding: 8px;
    border-radius: 10px;
    min-height: 200px;
  }
  .workshop-speaker-item .speaker-item-images{
    width: 180px;
    height: 180px;
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    border-radius: 90px;
    float:left;
    margin: 0 8px;
    /*clear: both;*/
  }
  .workshop-speaker-item .speaker-item-intro{
    text-align: justify;
    padding: 0 8px;
    padding-top: 40px;
    font-size: 16px;
  }
  .speaker-item-intro .item-name{
    margin-bottom: 8px;
    font-weight: 600;
  }
  .report-item-contain .report-title-contain{
    text-align: center;
    margin-top: 16px;
    font-size: 18px;
    color: #0053a1;
    font-weight: 700;

  }
  .report-abstract{
    text-indent: 2em;
    text-align: justify;
    padding: 0 8px;
  }
  .speakerandpanel-contain{
    margin-left: 50px;
    font-weight: 600;
  }
  .small-label{
    font-size: 14px;
    font-weight: normal;
  }
  .back-page-btn{
    text-align: right;
    color: #409EFF;
    padding: 8px;
  }
  .back-page-btn:hover{
    color: #0053a1;
    cursor: pointer;
  }

  @media screen and (max-width: 800px){
    .content-item {
      margin: 30px auto;
      margin-bottom: 30px;
    }
    /*.program_banner{*/
      /*background-image: url("../../static/images/workshop_mobile_banner.jpg");*/
      /*background-size: cover;*/
      /*background-position:left;*/
    /*}*/
    .item-title-content{
      position: relative;
      /*top:-38px;*/
    }
    .item-content{
      margin-top: 0px;
    }

  }
  @media screen and (max-width: 410px){
    .workshop-speaker-contain{
      justify-content:center ;
    }
    .report-item-contain .report-title-contain{
      font-size: 16px;

    }
    .workshop-speaker-item .speaker-item-intro{
      white-space: pre-wrap;
      word-wrap:break-word;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/WorkshopItem.vue